export const CONTENT = {
  GET_APP: {
    TITLE: "Go to Aviation Weather App",
    DESCRIPTION: "Click the button below to download and get full details.",
  },
};
